import React from 'react';
import { cn } from '@cotera/client/v0/lib/utils';
import { Avatar, AvatarFallback } from '@cotera/client/v0/components/ui/avatar';
import { avatarColor, memberInitials } from './use-org-members';

/**
 * Initial-avatar filled with a per-person theme color (keyed to a stable member
 * id) and white initials, so a row of them stays legible while letting you tell
 * people apart at a glance.
 */
export const MemberAvatar: React.FC<{
  seed: string;
  label: string | null;
  className?: string;
  textClassName?: string;
}> = ({ seed, label, className, textClassName }) => {
  const color = avatarColor(seed);
  return (
    <Avatar className={cn('h-5 w-5', className)}>
      <AvatarFallback
        className={cn('font-medium text-white', textClassName ?? 'text-[9px]')}
        style={{ backgroundColor: color }}
      >
        {memberInitials(label ?? '?')}
      </AvatarFallback>
    </Avatar>
  );
};
